import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  pending: false,
  list: [],
  perUsers: {}
});

export function setList(state, list) {
  const jsState = state.toJS();
  const { perUsers } = jsState;
  list.forEach(item => {
    if (perUsers[item.userId] === undefined) {
      perUsers[item.userId] = [];
    }
    perUsers[item.userId].push(item);
  });
  return state.merge({ list, perUsers });
}

export function setPendingSelf(state, pending = true) {
  return state.set('pending', !!pending);
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'BOXSTATS_PENDING':
      return setPendingSelf(state, action.pending);

    case 'BOXSTATS_BETWEENSTAMP':
      return setList(state, action.list, action.from, action.to);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/boxStats.js